import React, { useState } from 'react';
import { fileExport, providers } from '../../api-services';
import moment from 'moment';
import { createTable } from '@tanstack/react-table';
import TableManager from '../../components/TableManager';
import AddProviderModal from './AddProviderModal';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { deleteProvider } from '../../api-services';
import swal from 'sweetalert';
import {
  faEdit,
  faEllipsisV,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { useMutation, useQueryClient } from 'react-query';

const table = createTable();
const Providers = () => {
  const [openModalProvider, setOpenModalProvider] = useState(false);
  const [editData, setEditData] = useState({});
  const queryClient = useQueryClient();
  const { mutateAsync: mutateAsyncDelete } = useMutation(
    'deleteProvider',
    (payload) => deleteProvider(payload),
    {
      onSuccess: (data) => {
        swal({
          text: data?.data?.message,
          icon: 'success',
          type: 'success',
          timer: 2000,
        }).then(() => {
          setEditData({});
          queryClient.invalidateQueries('providers');
        });
      },
      onError: (error) => {
        swal({
          title: error?.response?.data?.message,
          type: 'danger',
          icon: 'error',
        });
      },
    },
  );
  const { isLoading: isLoadingExporting, mutateAsync: mutateAsyncExport } =
    useMutation('fileExport', (payload) => fileExport(payload, 'provider'), {
      onSuccess: (data) => {
        window.open(data?.data?.data);
      },
      onError: (error) => {
        swal({
          title: error?.response?.data?.message,
          type: 'danger',
          icon: 'error',
        });
      },
    });

  const handleAddProvider = () => {
    setEditData({});
    setOpenModalProvider(true);
  };

  const handleDelete = async ({ uniquecode }) => {
    swal({
      text: 'Are you sure you want to delete this Provider ?',
      buttons: true,
      icon: 'warning',
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          await mutateAsyncDelete({ uniquecode });
        } catch (error) {
          console.log(error);
        }
      }
    });
  };

  const handleUpdate = (data) => {
    setEditData(data);
    setOpenModalProvider(true);
  };

  const handleFileExport = async (payload) => {
    await mutateAsyncExport(payload);
  };

  const columns = [
    table.createDataColumn('created_at', {
      id: 'created_at',
      header: 'Date',
      isSortable: true,
      cell: (props) => moment(props.getValue()).format('YYYY-MM-DD: HH:mm:ss'),
    }),

    table.createDataColumn('name', {
      id: 'name',
      header: 'Name',
    }),
    table.createDataColumn('remove_prefix', {
      id: 'remove_prefix',
      header: 'Remove Prefix',
    }),
    table.createDataColumn('add_prefix', {
      id: 'add_prefix',
      header: 'Add Prefix',
    }),
    table.createDataColumn('request_mode', {
      id: 'request_mode',
      header: 'Mode',
    }),
    table.createDataColumn('host_ip_inbound', {
      id: 'host_ip_inbound',
      header: 'Inbound IP',
    }),
    table.createDataColumn('host_ip_outbound', {
      id: 'host_ip_outbound',
      header: 'Outbound IP',
    }),
    table.createDataColumn('allow_codecs', {
      id: 'allow_codecs',
      header: 'Allow Codecs',
    }),
    table.createDataColumn('type', {
      id: 'type',
      header: 'Type',
    }),
    table.createDataColumn('status', {
      id: 'status',
      header: 'Status',
      cell: (props) =>
        props.getValue() === 'A' ? (
          <a className="text-success" href="#">
            Activated
          </a>
        ) : (
          <a className="text-danger" href="#">
            Deactivated
          </a>
        ),
    }),

    table.createDisplayColumn({
      id: 'action',
      header: 'Action',
      cell: (props) => (
        <span>
          <Dropdown className="dropdown_dot mx-auto">
            <Dropdown.Toggle
              id="dropdown-basic"
              className="btn-light-blue btn-action "
            >
              <FontAwesomeIcon icon={faEllipsisV} />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item
                href={void 0}
                onClick={() => handleUpdate(props.row.original)}
              >
                <FontAwesomeIcon icon={faEdit} /> Edit
              </Dropdown.Item>
              <Dropdown.Item
                href={void 0}
                onClick={() => handleDelete(props.row.original)}
              >
                <FontAwesomeIcon icon={faTrash} />
                Delete
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </span>
      ),
    }),
  ];

  return (
    <>
      <TableManager
        table={table}
        columns={columns}
        fetcherKey="providers"
        fetcherFn={providers}
        title="Providers"
        cta={true}
        ctaFunction={handleAddProvider}
        ctaLabel="Add Provider"
        shouldExport={false}
        exportCtaFn={handleFileExport}
        isExporting={isLoadingExporting}
      />
      <AddProviderModal
        setOpenModal={setOpenModalProvider}
        openModal={openModalProvider}
        editData={editData}
        setEditData={setEditData}
      />
    </>
  );
};

export default Providers;
